class Collection {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.stickyHero = this.el.querySelector('.js-hero')
    this.head = this.el.querySelector('.js-head')
    this.headHeight = this.head.offsetHeight
    this.lastScroll = 0
  }

  bindEvents() {
    window.addEventListener('scroll', this.onScroll.bind(this))
  }

  onScroll() {
    let scrollY = window.pageYOffset || document.documentElement.scrollTop
    if(scrollY >= this.headHeight) {
      this.stickyHero.classList.add('hero--has-background')
      this.stickyHero.classList.remove('hero--no-background')
    }

    if(this.lastScroll == 0 || scrollY <= this.headHeight) {
      this.stickyHero.classList.remove('hero--has-background')
      this.stickyHero.classList.add('hero--no-background')
    }

    this.lastScroll = scrollY
  }
}

export default Collection
